import {
  Modal,
  ModalActionButton,
  ModalActions,
  ModalCloseIconButton,
  ModalContent,
  ModalTitle,
  Stack,
  Typography,
} from '@ace-clublabs/shared-component-library';
import { highlightAddressDifference } from '../utils/helpers';
import { Address } from '@lib/types';
import { ICorrectedResidence } from '../containers/AddressPage';

interface IAddressCompareModal {
  isOpen: boolean;
  onClose: () => void;
  isAddressCorrected: boolean;
  addressForm: Address;
  correctedAddress: ICorrectedResidence | null;
  acceptCorrectionClick?: () => void;
  navigateToNextPage: () => void;
}

export const AddressCompareModal = ({
  isOpen,
  onClose,
  isAddressCorrected,
  addressForm,
  correctedAddress,
  acceptCorrectionClick,
  navigateToNextPage,
}: IAddressCompareModal) => {
  return (
    <Modal open={isOpen} onClose={onClose} className="address-compare-modal">
      <ModalTitle
        id={`addressCompareModalTitle`}
        sx={{
          fontSize: '20px !important',
          fontWeight: '700',
          marginRight: '24px !important',
          marginBottom: '0 !important',
        }}
      >
        {isAddressCorrected
          ? 'We had trouble verifying your address'
          : 'We had trouble verifying your address. Please confirm it.'}
        <ModalCloseIconButton aria-label="Close" id="modalCloseButton" onClick={onClose} />
      </ModalTitle>

      <ModalContent id="modal-content-remove">
        <Stack className="address-compare-container" gap={'1rem'} marginTop={'1rem'}>
          <Stack flexDirection="column" className="address-compare-column qm-mask" data-di-mask="true">
            <Typography variant="b1Bold" className="original-address-title">
              You entered:
            </Typography>
            <Stack className="original-address-detail">
              <Typography variant="b1Regular">{addressForm.streetAddress}</Typography>
              <Typography variant="b1Regular">
                {addressForm.city}, {addressForm.state} {addressForm.zipCode}
              </Typography>
            </Stack>
          </Stack>
          {isAddressCorrected ? (
            <Stack className="address-compare-column qm-mask" data-di-mask="true">
              <Typography variant="b1Bold" className="suggested-address-title">
                Suggested address:
              </Typography>
              <Stack className="suggested-address-detail">
                <Typography variant="b1Regular">
                  {highlightAddressDifference(addressForm.streetAddress, correctedAddress!.address?.streetAddress)}
                </Typography>
                <Typography variant="b1Regular">
                  {highlightAddressDifference(addressForm.city, correctedAddress!.address?.city)},{' '}
                  {highlightAddressDifference(addressForm.state, correctedAddress!.address?.state)}{' '}
                  {highlightAddressDifference(addressForm.zipCode, correctedAddress!.address?.zipCode)}
                </Typography>
              </Stack>
            </Stack>
          ) : null}
        </Stack>
      </ModalContent>
      {isAddressCorrected ? (
        <ModalActions
          actionLayout={{
            sm: 'fullWidth',
            md: 'fullWidth',
            lg: 'fullWidth',
            xl: 'fullWidth',
          }}
          sx={{ marginTop: '1rem !important' }}
        >
          <ModalActionButton
            variant="outlined"
            id="useOriginalAddress"
            label="Use original address"
            onClick={navigateToNextPage}
          />
          <ModalActionButton
            variant="contained"
            id="acceptCorrections"
            label="Accept corrections"
            onClick={acceptCorrectionClick}
          />
        </ModalActions>
      ) : (
        <ModalActions
          actionLayout={{
            sm: 'fullWidth',
            md: 'fullWidth',
            lg: 'fullWidth',
            xl: 'fullWidth',
          }}
        >
          <ModalActionButton variant="outlined" id="editAddress" label="Edit" onClick={onClose} />
          <ModalActionButton
            variant="contained"
            id="continue"
            label="Continue with my address"
            onClick={navigateToNextPage}
          />
        </ModalActions>
      )}
    </Modal>
  );
};
